__turbopack_context__.v({
  "active": "x6Lcxq_active",
  "hasSelection": "x6Lcxq_hasSelection",
  "text": "x6Lcxq_text",
  "title": "x6Lcxq_title",
  "wrapper": "x6Lcxq_wrapper",
});
